
define('template!adminColorSelectionsEditPopupView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="popup-body">\n  <div class="cs-fields">\n    <div class="form-row cs-code">\n      <label>' +
((__t = ( _.escape(labels.code) )) == null ? '' : __t) +
'</label>\n      <input type="text" class="form-control js-code" value="' +
((__t = ( _.escape(code) )) == null ? '' : __t) +
'" maxlength="64"/>\n    </div>\n    <div class="form-row cs-name">\n      <label>' +
((__t = ( _.escape(labels.name) )) == null ? '' : __t) +
'</label>\n      <input type="text" class="form-control js-name" value="' +
((__t = ( _.escape(name) )) == null ? '' : __t) +
'" maxlength="255"/>\n    </div>\n  </div>\n  <div class="form-row">\n    <label>' +
((__t = ( _.escape(labels.description) )) == null ? '' : __t) +
'</label>\n    <input type="text" class="form-control js-description" value="' +
((__t = ( _.escape(description) )) == null ? '' : __t) +
'" maxlength="255"/>\n  </div>\n\n  <div class="form-row">\n    <label>' +
((__t = ( _.escape(labels.colors) )) == null ? '' : __t) +
' <span class="cs-count js-count"></span></label>\n    <div class="cs-colors js-colors"></div>\n  </div>\n\n  <div class="cs-add">\n    <div class="cs-add-pantone">\n      <label>' +
((__t = ( _.escape(labels.addPantone) )) == null ? '' : __t) +
'</label>\n      <div class="cs-add-row">\n        <select class="form-control js-library">\n          <option value="">' +
((__t = ( _.escape(labels.allLibraries) )) == null ? '' : __t) +
'</option>\n        </select>\n        <input type="search" class="form-control js-pantone-search" placeholder="' +
((__t = ( _.escape(labels.pantonePlaceholder) )) == null ? '' : __t) +
'"/>\n      </div>\n      <div class="cs-results js-results"></div>\n    </div>\n    <div class="cs-add-rgb">\n      <label>' +
((__t = ( _.escape(labels.addRgb) )) == null ? '' : __t) +
'</label>\n      <div class="cs-add-row">\n        <input type="color" class="js-rgb-picker" value="#3a6dd8"/>\n        <input type="text" class="form-control js-rgb-hex" value="#3a6dd8" maxlength="7"/>\n        <button type="button" class="btn btn-default js-rgb-add">' +
((__t = ( _.escape(labels.add) )) == null ? '' : __t) +
'</button>\n      </div>\n      <div class="cs-hint">' +
((__t = ( _.escape(labels.rgbHint) )) == null ? '' : __t) +
'</div>\n    </div>\n  </div>\n\n  <div class="form-row cs-techniques">\n    <label>' +
((__t = ( _.escape(labels.techniques) )) == null ? '' : __t) +
'</label>\n    <div class="js-techniques"></div>\n    <div class="cs-hint">' +
((__t = ( _.escape(labels.techniquesHint) )) == null ? '' : __t) +
'</div>\n  </div>\n\n  <div class="error-box js-error" style="display: none;"></div>\n</div>\n\n<div class="popup-footer">\n  <button type="button" class="btn btn-primary js-save">' +
((__t = ( _.escape(labels.save) )) == null ? '' : __t) +
'</button>\n  <button type="button" class="btn js-close">' +
((__t = ( _.escape(labels.close) )) == null ? '' : __t) +
'</button>\n</div>\n';

}
return __p
};});

